import { Tracker } from 'utils/tracking/providers/types';
import Analytics, { AnalyticsInstance } from 'analytics';
// @ts-ignore
import googleAnalytics from '@analytics/google-analytics';
// @ts-ignore
import googleTagManager from '@analytics/google-tag-manager';

export default class GoogleAnalyticsTracker implements Tracker {
  private instance: AnalyticsInstance;

  constructor(analyticsTrackingId: string | undefined, tagManagerId: string | undefined) {
    const plugins = [];

    if (analyticsTrackingId) {
      plugins.push(
        googleAnalytics({
          trackingId: analyticsTrackingId,
        }),
      );
    }

    if (tagManagerId) {
      plugins.push(
        googleTagManager({
          containerId: tagManagerId,
        }),
      );
    }

    this.instance = Analytics({
      plugins,
    });
  }

  trackPageView(pathname: string): void {
    this.instance.page({
      url: pathname,
    });
  }
}
